import { find } from 'lodash';

class DaySelectController {

    constructor(dayService, messageService) {
        this.dayService = dayService;
        this.messageService = messageService;
    }

    $onInit () {
        this.dayService.findAll(-1)
            .then(day => this.day = day)
            .catch(errors => {
                this.messageService.failure(errors);
                this.messageService.push();
            });
    }
}

DaySelectController.$inject = ['dayService', 'messageService'];

export default DaySelectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/controllers/day.select.controller.js